import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { translate } from "../../../intl";

interface FileAttachDropzoneProps {
  name: string;
  isLimitReached: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
  handleDropzoneClick: () => void;
  handleDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
  handleDrop: (e: React.DragEvent<HTMLDivElement>) => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  maxFileSizeMB: number;
  maxFiles: number;
}

const FileAttachDropzone: React.FC<FileAttachDropzoneProps> = ({
  name,
  isLimitReached,
  inputRef,
  handleDropzoneClick,
  handleDragOver,
  handleDrop,
  handleInputChange,
  maxFileSizeMB,
  maxFiles,
}) => (
  <div
    className={`file-attach__dropzone${isLimitReached ? " file-attach__dropzone--disabled" : ""}`}
    aria-disabled={isLimitReached}
    onDragOver={handleDragOver}
    onDrop={handleDrop}
    onClick={handleDropzoneClick}
    tabIndex={0}
    role="button"
    aria-label={translate("genericComponents.file.clickToUpload")}
  >
    <label
      htmlFor={name}
      className="file-attach__upload-action"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <FontAwesomeIcon icon={faPaperclip} className="file-attach__clip" />
      <span className="file-attach__upload-link">
        {translate("genericComponents.file.clickToUpload")}
      </span>{" "}
      {translate("genericComponents.file.orDragAndDrop")}
      <input
        ref={inputRef}
        tabIndex={-1}
        type="file"
        id={name}
        name={name}
        multiple
        onClick={(e) => {
          e.stopPropagation();
        }}
        onChange={handleInputChange}
        value=""
        className="file-attach__input"
        aria-disabled={isLimitReached}
        disabled={isLimitReached}
      />
    </label>
    <div className="file-attach__upload-limits">
      ({translate("genericComponents.file.maxFileSize", { maxFileSize: maxFileSizeMB })} /{" "}
      {translate("genericComponents.file.maxFileNum", { maxFileNum: maxFiles })})
    </div>
  </div>
);

export default FileAttachDropzone;
